import overworldTileset from './overworldTileset';
export {
  parseTilesetConfig,
  normalizeTilesetConfig,
  resolveTilesetImageSrc,
  resolveTerrainFrame,
  terrainHasCompatibleNeighbor,
  calculateTerrainBitmask,
  resolveTerrainSourceRect,
  recommendTerrainRenderMode,
  getDefaultTerrainRenderMode,
  normalizeTerrainRenderMode
} from './utils';

export const TILESETS = {
  overworld_v1: overworldTileset
};

export function getTilesetConfig(tilesetId = 'overworld_v1') {
  return TILESETS[tilesetId] || overworldTileset;
}

export function getTerrainCatalog(tilesetId = 'overworld_v1') {
  const tileset = getTilesetConfig(tilesetId);
  return tileset.terrains || [];
}

export function resolveTerrainCatalog(tilesetId = 'overworld_v1', config = null) {
  if (config && Array.isArray(config.terrains) && config.terrains.length > 0) {
    return config.terrains;
  }
  return getTerrainCatalog(tilesetId);
}
